import { defineComponent } from 'vue'

import { Item, Location as LocationEntity, SearchResult, SpecimenResource, getTranslatedString } from '@skinsoft/types'
import { itemSelectors, locationSelectors, specimenSelectors } from '@skinsoft/selectors'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { searchResultSelectors } from '@skinsoft/search-data-store'

export const Location = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['item', 'displayPath', 'dataCy', 'itemType'],
    template: require('./location.html'),
    data() {
        return {
            locationSelectors,
            location: null as any as LocationEntity,
            locationTitle: "",
            fullPathLocation: "",
            firstSynonym: "",
            isPermanent: false,
        }
    },
    created() {
        this.subscribe();
    },
    methods: {
        subscribe() {
            let locationId = null
            switch(this.itemType) {
                case 'Item':
                    locationId = itemSelectors.realTimeLocation(this.item as Item)

                    // Taking permanent location if no real-time one is available
                    if (!locationId) {
                        locationId = itemSelectors.permanentLocation(this.item as Item);
                        this.isPermanent = true;
                    }

                    if (!locationId) {
                        this.$emit('ready');
                        return;
                    }

                    this.subscribeTo(
                        this.$locationDataStore.fetchOne(locationId),
                        async location => {
                            this.$emit('ready');
                            this.location = location;
                            this.locationTitle = locationSelectors.translatedTitle(location, this.getAppLocale())

                            this.fullPathLocation = await this.$locationDataStore.resolvePath(
                                // @ts-ignore
                                locationSelectors.pathIds(location),
                                this.getAppLocale()
                            )

                            this.firstSynonym = locationSelectors.firstSynonym(location, this.getAppLocale())
                        },
                        'location',
                    );
                    break

                case 'Specimen':
                    locationId = specimenSelectors.realTimeLocation(this.item as SpecimenResource)

                    // Taking permanent location if no real-time one is available
                    if (!locationId) {
                        locationId = specimenSelectors.permanentLocation(this.item as SpecimenResource);
                        this.isPermanent = true;
                    }

                    if (!locationId) {
                        this.$emit('ready');
                        return;
                    }

                    this.subscribeTo(
                        this.$locationDataStore.fetchOne(locationId),
                        async location => {
                            this.$emit('ready');
                            this.location = location;
                            this.locationTitle = locationSelectors.translatedTitle(location, this.getAppLocale())

                            this.fullPathLocation = await this.$locationDataStore.resolvePath(
                                // @ts-ignore
                                locationSelectors.pathIds(location),
                                this.getAppLocale()
                            )

                            this.firstSynonym = locationSelectors.firstSynonym(location, this.getAppLocale())
                        },
                        'location',
                    );
                    break

                case 'SearchResult':
                    // @ts-ignore
                    this.location = searchResultSelectors.realTimeLocation(this.item as SearchResult)
                    if(!this.location) {
                        this.isPermanent = true
                        // @ts-ignore
                        this.location = searchResultSelectors.permanentLocation(this.item as SearchResult)
                        if(!this.location) {
                            this.$emit('ready')
                            return
                        }
                    }
                    this.locationTitle = getTranslatedString((this.location as any).value, this.getAppLocale())
                    this.fullPathLocation = getTranslatedString((this.location as any).path, this.getAppLocale())
                    this.$emit('ready')
                    break
            }
        },
    },
    watch: {
        item() {
            this.isPermanent = false;
            this.unsubscribeFrom('location');
            this.subscribe();
        },
    },
})
